import React from 'react';

const SvgGw = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="GW_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="GW_svg__b" fill="#fff">
        <use xlinkHref="#GW_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#GW_svg__a" />
      <path fill="#1AB558" mask="url(#GW_svg__b)" d="M0 9.333h28V20H0z" />
      <path fill="#FFD952" mask="url(#GW_svg__b)" d="M0 0h28v9.333H0z" />
      <path fill="#E72B42" mask="url(#GW_svg__b)" d="M0 0h10.667v20H0z" />
      <path
        fill="#262626"
        mask="url(#GW_svg__b)"
        d="M5.333 11.278l-1.959 1.419.744-2.302L2.163 8.97l2.419-.004.751-2.3.752 2.3 2.419.004-1.955 1.425.744 2.302z"
      />
    </g>
  </svg>
);

export default SvgGw;
